<div class="flex items-center justify-center h-screen">
  <bnd-loading size="lg" />
</div>
